import { render, staticRenderFns } from "./Macchina.vue?vue&type=template&id=6e27a340&"
import script from "./Macchina.vue?vue&type=script&lang=js&"
export * from "./Macchina.vue?vue&type=script&lang=js&"
import style0 from "./Macchina.vue?vue&type=style&index=0&id=6e27a340&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports